<template>
  <el-form style="margin: 0 10px" ref="form" :model="form" label-position="top">
    <el-form-item label="模板状态" prop="state" :rules="{ required: true, message: '请选择模板状态' }">
      <el-radio-group v-model="form.state">
        <el-radio label="Published">审核成功</el-radio>
        <el-radio label="Rejected">需改进</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      v-if="form.state == 'Rejected'"
      label="拒绝理由"
      prop="message"
      :rules="{ required: true, message: '请输入拒绝理由' }"
    >
      <el-input v-model="form.message" placeholder="请输入拒绝理由"></el-input>
    </el-form-item>
    <el-form-item v-if="form.state == 'Published'" label="选项">
      <el-checkbox v-model="form.isFeatured">精选模板</el-checkbox>
    </el-form-item>
  </el-form>

  <el-divider></el-divider>

  <div class="el-dialog__footer">
    <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
    <el-button @click="btnCancelClick">取 消</el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IElForm } from '@/types/element';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/themes';

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    theme: {
      type: Object as PropType<ITheme>,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.theme },
    };
  },
  methods: {
    apiSubmit() {
      api.submit(this.form, (res) => {
        if (!res) return;

        utils.success('模板状态设置成功！');
        this.$emit('submit', this.form);
      });
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    theme(value) {
      this.form = { ...value };
    },
  },
});
</script>
